export const data = [
  {
    title: "Find a Teacher Anywhere",
  },
  {
    title: "Globally Distributed Institution",
  },
];
